//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import {
    ExhibationList,
    IndustryList,
    PlatformUrl,
    QuickList,
    ServiceList,
    ZoneList
} from "~/constant/Area";
import config from "~/config";
import { Identities } from "~/constant/Identities";
import portal from "~/net/portal";

const CHATBOT_URL = "https://knowchat.jstec.com.cn/ui/chat/30a1b90ab0931e93";
export default {
    name: "SideNav",
    data() {
        return {
            backPosition: 0,
            zoneList: ZoneList,
            industryList: IndustryList,
            exhibationList: ExhibationList,
            serviceList: ServiceList,
            quickList: QuickList,
            platformUrl: PlatformUrl,
            showMaxChatWindow: false, // 控制智能问答窗口
            iframeLoaded: false, // iframe加载状态
            iframeMaxLoaded: false, // 最大化iframe加载状态
            chatBotUrl: "https://knowchat.jstec.com.cn/ui/chat/30a1b90ab0931e93", // 智能问答URL
            identityVisible: {
                show: false,
                content: ""
            },
            businessBrowserUrl: config.businessBrowserUrl,
            backVisible: true,
            backInterval: null
        };
    },
    computed: {
        ...mapState(["user", "identities", "courier"]),
        sideNavVisibity() {
            if (
                this.$router.currentRoute.path.includes("/achievement") ||
                this.$router.currentRoute.path.includes("/Intermediary") ||
                this.$router.currentRoute.path.includes("/demandDashboard/dashboard") ||
                this.$router.currentRoute.path.includes("/demandDashboard") ||
                this.$router.currentRoute.path.includes("/roadShow") ||
                this.$router.currentRoute.path.includes("/overall") ||
                this.$router.currentRoute.path.includes("/supplyNew") ||
                this.$router.currentRoute.path.includes("/collegeNew") ||
                this.$router.currentRoute.path.includes("/talentZone") ||
                this.$router.currentRoute.path.includes("/finance") ||
                this.$router.currentRoute.path.includes("/activityTech") ||
                this.$router.currentRoute.path.includes("/lasa")
            ) {
                return false;
            }
            return this.$config.AREA_CODE == "jiangsu";
        }
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
        if (this.backInterval) {
            clearInterval(this.backInterval);
        }
    },
    methods: {
        chatBot() {
            if (!this.user) {
                this.$router.push("/login");
                return;
            }
            this.showMaxChatWindow = !this.showMaxChatWindow;
        },
        getUrl(item) {
            if (item.url == "yangzhou") {
                return "https://yangzhou.jstec.com.cn/yangzhou";
            } else {
                return "/goBranch/" + item.url;
            }
        },
        gotoUrl(item) {
            if (item.url.indexOf("yqgx") > 0 || item.url.indexOf("kjttest5") > 0) {
                if (this.user == null) {
                    window.open(item.url);
                } else {
                    portal.selectThirdUserLogin().then((res) => {
                        if (res.code == "0000" && res.data) {
                            window.open(
                                `${item.url}?account=${res.data.channelUserName}&password=${res.data.channelUserPassword}`
                            );
                        } else {
                            window.open(item.url);
                        }
                    });
                }
                return;
            }

            if (item.hasOwnProperty("url")) {
                window.location.href = item.url;
            } else {
                this.goToLink(item.redirect);
            }
        },
        goToLink(redirect) {
            if (this.user == null) {
                this.$router.push("/login");
            } else if (redirect == "/business") {
                this.$store.dispatch("CheckRealName").then(
                    (res) => {
                        let role = "seller";
                        if (this.identities.length > 0) {
                            const list = [];
                            this.identities.forEach((item) => {
                                if (item.isBind != 2)
                                    // 被解绑的可以忽略
                                    list.push(Identities.find((_) => _.key == item.type));
                            });
                            if (list.length > 0)
                                role = list.sort((a, b) => {
                                    return a.order - b.order;
                                })[0].role;
                        }
                        window.location.href =
                            `${this.businessBrowserUrl + redirect}` + `?role=${role}&from=portal`;
                    },
                    (err) => {
                        this.$store.commit("SET_REALNAME", true);
                    }
                );
            } else {
                window.location.href = `${this.businessBrowserUrl + redirect}`;
            }
        },
        operateClick(value) {
            this.identityVisible.show = false;
            window.location.href = `${this.businessBrowserUrl}/identity`;
        },
        handleScroll() {
            this.backVisible = window.pageYOffset > 200;
        },
        backToTop() {
            this.$store.commit("SET_BACKTOP");
            const start = window.pageYOffset;
            let i = 0;
            this.backInterval = setInterval(() => {
                const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500));
                if (next <= this.backPosition) {
                    window.scrollTo(0, this.backPosition);
                    clearInterval(this.backInterval);
                } else {
                    window.scrollTo(0, next);
                }
                i++;
            }, 16.7);
        },
        easeInOutQuad(t, b, c, d) {
            if ((t /= d / 2) < 1) return (c / 2) * t * t + b;
            return (-c / 2) * (--t * (t - 2) - 1) + b;
        },
        consultAdmin() {
            this.$store.dispatch("consultCourierAdmin");
        }
    }
};
